<template>
  <div>
    <label for="email" class="block text-sm font-medium text-gray-700">{{ title }}</label>
    <div class="mt-1 relative rounded-md shadow-sm">
      <input v-model.trim="$v.newValue.$model" type="email" name="email" id="email" class="focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md">
    </div>
  </div>
</template>

<script>

import { required } from "vuelidate/lib/validators"

import fieldHelper from "@/components/SideEditor/BlockConfigurationTabs/FormList/field-helper"

export default {
  mixins: [fieldHelper],
  validations: {
    newValue: { required },
  },
}

</script>
